import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { ICondoReviewBookState, IMenuState } from 'src/store/slices/index';
import { ClockSvg, InfoSvg } from 'src/assets/index';
import { RootState } from 'src/store';
import { PriceSkeleton, UnitMainInfo } from 'src/components/components/index';
import { formatMoney } from 'src/utils/index';
import { CondoDiscountCode } from '../condo-discount-code';
import './style.scss';

interface IMapStateToProps {
  condoReviewBookStore: ICondoReviewBookState;
  navigationMenuStore: IMenuState;
}

interface IProps extends IMapStateToProps {}

const ZERO = 0;
const ONE = 1;

class CondoUnitInfoComponent extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { condoBookingSummary, isUpdatePrice, loadingBooking, bookingComplete } =
      this.props.condoReviewBookStore;
    const { items } = this.props.navigationMenuStore;
    const { rating, supplierIdentifier } = condoBookingSummary;
    const {
      name,
      fullAddress,
      titleImage,
      unitName,
      unitDescription,
      nightsCount,
      totalGuests,
      totalChildren,
      totalBedrooms,
      totalBathrooms,
      checkIn,
      checkOut,
      bookingPrice,
      maxOccupancy,
      balance,
    } = condoBookingSummary.bookingCard;
    const { publicPrice, savings, payNowPrice, totalTaxes } = bookingPrice;
    const isNotification = loadingBooking;

    return (
      <div className="unit-info">
        <div className="unit-info__wrapper">
          <UnitMainInfo
            imageUrl={titleImage}
            title={name}
            address={fullAddress}
            unitName={unitName}
            unitDescription={unitDescription}
            adultsCount={totalGuests - totalChildren}
            childrenCount={totalChildren}
            bedroomsCount={totalBedrooms}
            bathroomsCount={totalBathrooms}
            maxOccupancy={maxOccupancy}
            checkIn={checkIn}
            checkOut={checkOut}
            nightsCount={nightsCount}
            price={bookingPrice?.publicPrice}
            checkOutTime={condoBookingSummary?.bookingPolicies?.checkInCheckOutInfo?.checkOutTime}
            checkInTime={condoBookingSummary?.bookingPolicies?.checkInCheckOutInfo?.checkInTime}
            isNotification={isNotification}
            bookingComplete={bookingComplete}
            rating={rating}
            supplierIdentifier={supplierIdentifier}
          />
          {!isNotification && (
            <>
              <div className="unit-info__content ">
                <h4 className="unit-info__price-title">
                  <FormattedMessage id="price.details" />
                </h4>
                {isUpdatePrice && <PriceSkeleton />}
                {!isUpdatePrice && (
                  <>
                    <div className="unit-info__price-info">
                      <p className="unit-info__price-info-text">
                        <FormattedMessage id="public.price.details" />{' '}
                        <FormattedMessage id="unit.count" values={{ count: ONE }} /> x{' '}
                        <FormattedMessage id="nights" values={{ count: nightsCount }} />
                      </p>
                      <p className="unit-info__price-info-text">
                        {formatMoney.format(publicPrice)}
                      </p>
                    </div>
                    {savings && (
                      <>
                        <div className="unit-info__price-info">
                          <p className="unit-info__price-savings-text">
                            <FormattedMessage
                              id={items?.promo ? 'savings' : 'member.savings.label'}
                            />
                          </p>
                          <p className="unit-info__price-savings-text">
                            -{formatMoney.format(savings)}
                          </p>
                        </div>
                      </>
                    )}
                    {!!balance && items?.pointsSettings.condo.isRemainingBalanceEnabled && (
                      <div className="room-info__price-credits">
                        <p className="room-info__price-credits-text">
                          <FormattedMessage id="leisure.credits.balance" /> {balance}
                        </p>
                      </div>
                    )}
                  </>
                )}
              </div>
              {!isUpdatePrice && (
                <>
                  <div className="unit-info__content border-content">
                    {!items?.promo && <CondoDiscountCode />}
                  </div>
                  <div className="unit-info__content pb-15">
                    <div className="unit-info__total-price-info-wrapper">
                      <div className="unit-info__total-price-info">
                        <p className="unit-info__price-info-text-total">
                          <FormattedMessage id="total.pay" />:
                        </p>
                      </div>
                      <div className="unit-info__price-info-amount-wrapper">
                        {!bookingComplete ? (
                          <p className="unit-info__public-price-amount">
                            {formatMoney.format(publicPrice)}
                          </p>
                        ) : null}
                        <p className="unit-info__pay-now-rice-amount">
                          {formatMoney.format(payNowPrice)}
                        </p>
                      </div>
                    </div>
                    {totalTaxes !== ZERO ? (
                      <p className="unit-info__note">
                        <FormattedMessage id="including.taxes.fees" />{' '}
                        {formatMoney.format(totalTaxes)}
                      </p>
                    ) : (
                      <p className="unit-info__note">
                        <FormattedMessage id="zero.charge.for.taxes.fees" />
                      </p>
                    )}
                  </div>
                </>
              )}
              <div className="unit-info__label">
                <p className="unit-info__label-text bold">
                  <InfoSvg />
                  <FormattedMessage id="additional.charges.may.apply.upon" />
                </p>
                <p className="unit-info__label-text">
                  <FormattedMessage id="refer.to.know.before.you.go" />
                </p>
              </div>
            </>
          )}
        </div>
        {!isNotification && (
          <div className="unit-info__label-footer">
            <ClockSvg />
            <p className="unit-info__label-text notification-text">
              <FormattedMessage id="act.fast" />
            </p>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    condoReviewBookStore: state.condoReviewBookStore,
    navigationMenuStore: state.navigationMenuStore,
  };
};

export const CondoUnitInfo = connect(mapStateToProps, null)(CondoUnitInfoComponent);
